import { SparkHorizontal, SparkVertical, SparkIconOnly } from "@/icons";
import type { BrandMarkProps } from "../types";

// SmartMarket's marks — the artwork the app already shipped, unchanged.
// The source SVGs (src/icons/spark_*.svg, drawn on a square 2000×2000 canvas)
// stay where they are; this file only fixes each mark's viewBox crop so a call
// site can render `<LogoWordmark className="h-7 w-auto" />` without knowing the
// numbers. The crops are the exact ones Brand.tsx and Sidebar.tsx used before,
// so every SmartMarket surface paints pixel-for-pixel as it did.

/** Horizontal wordmark, cropped to the artwork's bounds. */
export function SmartMarketWordmark(props: BrandMarkProps) {
  return <SparkHorizontal viewBox="243 632 1611 628" {...props} />;
}

/** Vertical icon-over-wordmark lockup, cropped to the artwork's bounds. */
export function SmartMarketStacked(props: BrandMarkProps) {
  return <SparkVertical viewBox="464 164 1044 1675" {...props} />;
}

/** Square icon-only mark, cropped to the artwork's bounds. */
export function SmartMarketMark(props: BrandMarkProps) {
  return <SparkIconOnly viewBox="94 17 1945 1945" {...props} />;
}

/**
 * The inline glyph — the icon-only mark on its FULL square canvas (no crop),
 * which is what `<Spark>` resolved to at every money and chrome call site
 * before the theme layer existed. It fills from `currentColor`, so the
 * `text-spark` / `text-warning` / `text-primary` tints at those call sites keep
 * working untouched. Serves as both the spark/reward icon and the currency
 * icon for this brand.
 */
export function SmartMarketGlyph(props: BrandMarkProps) {
  return <SparkIconOnly {...props} />;
}
